export enum amountSavesValues {
	MOINS_1000 = 500,
	DE_1001_A_2000 = 1500,
	DE_2001_A_4000 = 3000,
	DE_4001_A_8000 = 6000,
	PLUS_DE_8001 = 8000
}
export enum amountHeritageOthersValues {
	MOINS_5000 = 2500,
	DE_5000_A_50000 = 25000,
	PLUS_50000 = 50000
}
export enum amountHeritageMoneyValues {
	MOINS_5000 = 2500,
	DE_5000_A_20000 = 12500,
	DE_20001_A_50000 = 35000,
	DE_50001_A_1M = 500000,
	PLUS_1M = 1000000
}
export enum amountHeritageRealEstateValues {
	MOINS_100000 = 5000,
	DE_100001_A_400000 = 25000,
	DE_400001_A_1M = 500000,
	DE_1M_A_2M = 1500000,
	PLUS_2M = 2000000
}
export enum amountHeritagePelAndCoValues {
	MOINS_10000 = 5000,
	DE_10000_A_50000 = 35000,
	DE_50001_A_250000 = 150000,
	DE_250001_A_500000 = 375000,
	PLUS_500000 = 500000
}
